/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_WelcomeInputs */

const en_signin_welcome = /** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back. Pick how you want to sign in.`)
};

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const ar_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const he_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const ur_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const es_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const fr_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const de_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const pt_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const hi_signin_welcome = en_signin_welcome;

/** @type {(inputs: Signin_WelcomeInputs) => LocalizedString} */
const bn_signin_welcome = en_signin_welcome;

/**
* | output |
* | --- |
* | "Welcome back. Pick how you want to sign in." |
*
* @param {Signin_WelcomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_welcome = /** @type {((inputs?: Signin_WelcomeInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_WelcomeInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_welcome(inputs)
	if (locale === "he") return he_signin_welcome(inputs)
	if (locale === "ur") return ur_signin_welcome(inputs)
	if (locale === "es") return es_signin_welcome(inputs)
	if (locale === "fr") return fr_signin_welcome(inputs)
	if (locale === "de") return de_signin_welcome(inputs)
	if (locale === "pt") return pt_signin_welcome(inputs)
	if (locale === "hi") return hi_signin_welcome(inputs)
	if (locale === "bn") return bn_signin_welcome(inputs)
	return /** @type {LocalizedString} */ ("Welcome back. Pick how you want to sign in.")
});